import { isNil } from 'lodash'

export const getValue = (value?: string | number | null | undefined) => {
  if (value === null || value === undefined || value === '') {
    return '-'
  }
  return value
}
export const getBooleanValue = (value?: boolean | null | undefined) => {
  if (isNil(value)) {
    return '-'
  }

  return value ? 'Yes' : 'No'
}
